/**
 * Review Belt — horizontal scroll behavior + centered arrow nav.
 * Scoped per-instance (multiple review belts can exist on the same page,
 * e.g. homepage + a landing page section).
 *
 * Filtering by segment tag (couples / hot-sleepers / pain-sleepers /
 * fitness-enthusiasts / trouble-sleepers) is intentionally NOT wired up yet.
 * Each <li class="review-card"> already carries the tags in a
 * data-tags="tag-one,tag-two" attribute. To switch on filtering later,
 * add buttons with a data-belt-filter="hot-sleepers" attribute and drop in:
 *
 *   document.querySelectorAll('[data-belt-filter]').forEach(function (btn) {
 *     btn.addEventListener('click', function () {
 *       var tag = btn.getAttribute('data-belt-filter');
 *       document.querySelectorAll('.review-card').forEach(function (card) {
 *         var tags = (card.getAttribute('data-tags') || '').split(',');
 *         card.hidden = tag !== 'all' && tags.indexOf(tag) === -1;
 *       });
 *     });
 *   });
 */
(function () {
  function initReviewBelt(belt) {
    var track = belt.querySelector('[data-belt-track]');
    var prevBtn = belt.querySelector('[data-belt-prev]');
    var nextBtn = belt.querySelector('[data-belt-next]');
    if (!track) return;

    function getStep() {
      var firstCard = track.querySelector('.review-card');
      return firstCard ? firstCard.getBoundingClientRect().width + 20 : 340;
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
      if (nextBtn) {
        nextBtn.disabled =
          track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  document.querySelectorAll('.review-belt').forEach(initReviewBelt);
})();
